import { ShortContentCompletedVideoView } from '../components/ShortContentCompletedVideoView';
import { useShortFromPropsOrParams } from '../shortContentHooks';
import { VideoPlayerWithControls } from '../../video';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentVideo = ({
  contentPlaylistId,
  displayAICompanion,
  handleAICompanionDisplay,
  shortId
}) => {
  const {
    short,
    playlistId
  } = useShortFromPropsOrParams({
    shortId,
    playlistId: contentPlaylistId
  });
  const {
    name,
    contentId
  } = short || {};
  const additionalTracking = useMemo(() => ({
    shortId,
    contentType: 'SHORT_FORM_CONTENT'
  }), [shortId]);
  if (!short) {
    return null;
  }
  return /*#__PURE__*/_jsx(VideoPlayerWithControls, {
    additionalTracking: additionalTracking,
    completedVideoView: /*#__PURE__*/_jsx(ShortContentCompletedVideoView, {}),
    displayAICompanion: displayAICompanion,
    enableAiCompanion: true,
    handleAICompanionDisplay: handleAICompanionDisplay,
    isPubliclyVisible: true // TODO: Update this to read short visibility when available
    ,
    playlistId: playlistId,
    shortId: contentId,
    shortName: name
  });
};
export default ShortContentVideo;